export default "__VITE_ASSET__827a85b2__"